export enum TaskState {
    New = "822c9874-750d-4142-857d-c5fed808b5f5",
    InProgress = "d5d54e33-2c2c-41ca-9d7c-86dd2742c1ee",
    AwaitingResponse = "744c6fad-c04c-458e-a0eb-243a2a6c97e7",
    ClosedIncomplete = "54eab322-f36e-4a62-9f01-623eefa94da6",
    ClosedComplete = "9c562024-739f-480a-893c-4b61cb7002f8"
}